import 'isomorphic-fetch';
import EmailNotificationsApiError from './EmailNotificationsApiError';
import { buildQueryParamsString, buildMetricsData } from '../../common/utils';
import metricsApi from '../../metrics/Api';
import { verticalIdToName } from '~/utils/verticals';
import { API_TIMEOUT } from '../../common/constants';

export const END_POINTS = {
  RESOLVE_ACT: '/resolveAct',
};

const FETCH_OPTIONS = {
  mode: 'cors',
  timeout: API_TIMEOUT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

class Api {
  constructor(urlBase) {
    this.urlBase = urlBase;
  }

  static get(url, metricsData) {
    const startTime = new Date();

    return fetch(url, { method: 'GET', ...FETCH_OPTIONS })
      .then(response => response.json())
      .then(body => {
        if (body.error) {
          throw new EmailNotificationsApiError(404, body.error);
        }

        metricsApi.incrementQuery(metricsData);

        const endTime = new Date();
        const responseTime = endTime - startTime;

        metricsApi.storeResponseTime({ ...metricsData, responseTime });

        return body;
      })
      .catch(error => {
        if (error.type === 'request-timeout') {
          metricsApi.incrementTimeout(metricsData);
        }

        metricsApi.incrementError(metricsData);

        throw new EmailNotificationsApiError(error.code, error.message);
      });
  }

  /**
   * Get Notifications Manager required params from act value
   *
   * @param  {object} data
   * @return {object}
   */
  getNotificationsParams(data, alertControlToken) {
    /* eslint-disable camelcase */
    const { country_code, vertical_id } = data;
    const composedPath = `${this.urlBase}${END_POINTS.RESOLVE_ACT}`;

    const queryParamsString = buildQueryParamsString({
      act: alertControlToken,
      countrycode: country_code,
      verticalid: vertical_id,
    });
    const url = `${composedPath}?${queryParamsString}`;

    const verticalName = verticalIdToName(vertical_id);
    const apiName = 'notificationParams';
    const apiResource = 'resolveAct';
    const metricsData = buildMetricsData(verticalName, country_code, apiName, apiResource);

    return Api.get(url, metricsData);
  }
}

export default Api;



// WEBPACK FOOTER //
// ./app/sdk/notifications/email/ApiNotificationsParams.js